import { InjectionToken } from '@angular/core';
import { SignalBased, WritableSignalBased } from '@core';
import { PaginationParams, ProductDetails } from '@models';
import { ExtraFilterControlName, FormState } from '@shared';
import { Subscription } from 'rxjs';

export type PriceFilters = Partial<Record<ExtraFilterControlName, number>>;

export type GetProductsParams = FormState & PriceFilters;

interface ProductListFacade {
  title?: string;
  subtitle?: string;
  products: ProductDetails[];
  isLoading: boolean;
  initialLoading: boolean;
  totalCount: number;
  showPaginationCount?: boolean;
  filters: GetProductsParams;

  getProducts(filter?: GetProductsParams, pagination?: PaginationParams): Subscription;
  seeMoreProducts(): void;
  setInitialState(products: ProductDetails[], totalCount: number, filters: GetProductsParams): void;
}

export type ProductListFacadeSignals = SignalBased<
  Omit<ProductListFacade, 'getProducts' | 'seeMoreProducts' | 'setInitialState' | 'products' | 'totalCount'>
> &
  WritableSignalBased<Pick<ProductListFacade, 'products' | 'totalCount'>> &
  Pick<ProductListFacade, 'getProducts' | 'seeMoreProducts' | 'setInitialState'>;
export const PRODUCT_LIST_FACADE = new InjectionToken<ProductListFacadeSignals>('PRODUCT_LIST_FACADE');
